<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="PN"><a href="#/DeGroat_Toughest_People_to_Love_text1#toc2">Part 1</a></p>
<p class="PT" id="toc_marker-3"><a href="#/DeGroat_Toughest_People_to_Love_text1#toc2">Understanding People</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DeGroat_Toughest_People_to_Love_text-3.vue?7b1d34dd